"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNTESFromGeneralActivityEffects = exports.GeneralActivitySchema = void 0;
const zod_1 = require("zod");
const serialised_eventr_date_1 = require("./serialised-eventr-date");
const start_or_end_enum_1 = require("./start-or-end-enum");
exports.GeneralActivitySchema = zod_1.z.object({
    _id: zod_1.z.string(),
    activity_name: zod_1.z.string(),
    location: zod_1.z.string().optional(),
    start: serialised_eventr_date_1.EventrDateFromStringSchema,
    end: serialised_eventr_date_1.EventrDateFromStringSchema,
    check_in: serialised_eventr_date_1.EventrDateFromStringSchema.optional(),
    startOrEnd: start_or_end_enum_1.StartOrEndEnum,
});
/**
 * A ZodEffects that transforms the general activity data into a UNTES.
 */
exports.UNTESFromGeneralActivityEffects = exports.GeneralActivitySchema.transform((activity) => {
    return {
        id: activity._id,
        date: activity.startOrEnd === 'start' ? activity.start : activity.end,
        section: 'general-activity',
        startOrEnd: activity.startOrEnd,
        primary: activity.activity_name,
        ...(activity.location ? { secondary: activity.location } : {}),
        ...(activity.check_in ? { checkIn: activity.check_in } : {}),
    };
});
